import { Switch, Table } from "antd";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import LockResetOutlined from "@mui/icons-material/LockResetOutlined";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { showSuccess } from "../../../../helpers/Notifications/Notification";
import {
  activateStateAdmin,
  resetStateAdminPassword,
} from "../../../../slices/StateDOTAdmin/userManagement.slice";
import { StateAdminManagementColumn } from "../../../../helpers/columns";
import { IconButton } from "../../../../components/ds";

const StateAdminTable = ({
  isListLoading,
  populateStateAdminList,
  paginationCurrentPage,
  searchItem,
  setPaginationCurrentPage,
  tableData,
  setTableData,
  setPaginationCurrentPageSize,
  paginationCurrentPageSize,
  handleViewOrganization,
}) => {
  const [paginationTotalPages, setPaginationTotalPages] = useState(0);
  const dispatch = useDispatch();

  const {
    stateAdminList,
    loading: APIdataloading,
    activateStateAdminLoading,
  } = useSelector((state) => state.stateAdminManagement);

  const onStateAdminActivation = (value, email) => {
    const data = {
      email: email,
      is_active: value,
    };
    dispatch(activateStateAdmin(data));
  };

  const handleResetPassword = (email) => {
    dispatch(resetStateAdminPassword({ email }, (msg) => showSuccess(msg)));
  };

  useEffect(() => {
    if (stateAdminList) {
      const { state_admin_data, state_admin_count } = stateAdminList;
      setPaginationTotalPages(state_admin_count);
      const formattedData = state_admin_data?.map((emp, index) => ({
        key: index + 1,
        slNo:
          (paginationCurrentPage - 1) * paginationCurrentPageSize + index + 1,
        name: emp?.name,
        email: emp?.email,
        activation: (
          <div className={"activation-container"}>
            <div
              className={emp?.is_active ? "active-tag tag" : "inactive-tag tag"}
            >
              {emp?.is_active ? "Active" : "Inactive"}
            </div>
            <Switch
              checkedChildren="On"
              unCheckedChildren="Off"
              checked={emp?.is_active}
              onChange={(value) => onStateAdminActivation(value, emp?.email)}
              className="activate-switch"
              loading={activateStateAdminLoading}
            />
          </div>
        ),
        moreOptions: (
          <div style={{ display: "inline-flex", gap: 2 }}>
            <IconButton
              label="View organizations"
              onClick={() => handleViewOrganization(emp)}
            >
              <VisibilityOutlined />
            </IconButton>
            <IconButton
              label="Reset password"
              onClick={() => handleResetPassword(emp?.email)}
            >
              <LockResetOutlined />
            </IconButton>
          </div>
        ),
      }));
      setTableData(formattedData);
    } else setTableData([]);
  }, [stateAdminList, stateAdminList?.state_admin_data]);

  const handlePaginationonChange = (pageNumber, size) => {
    setPaginationCurrentPage(pageNumber);
    setPaginationCurrentPageSize(size);
    populateStateAdminList(searchItem, pageNumber, size);
  };

  return (
    <Table
      className="list-table platform-admin-org-management-table"
      dataSource={tableData}
      columns={StateAdminManagementColumn}
      pagination={{
        total: paginationTotalPages,
        onChange: handlePaginationonChange,
        showSizeChanger: true,
        position: ["topRight", "bottomRight"],
        showTotal: (total, range) =>
          `Showing ${range[0]}–${range[1]} of ${total}`,
      }}
      scroll={{ x: true, y: 475 }}
      loading={isListLoading || APIdataloading}
      locale={{
        emptyText: !(isListLoading || APIdataloading)
          ? searchItem
            ? "No matching records found."
            : "No members present in the portal."
          : "",
      }}
    />
  );
};

export default StateAdminTable;
